import { defineStore } from 'pinia';

export const useFeatureFlagStore = defineStore({
  id: 'featureFlag',

  state: () => ({
    permissionsFlag: false as boolean,
    ideaVoterFlag: false as boolean,
    notificationFlag: false as boolean,
  }),

  actions: {
    setPermissionFlag(permissionsFlag: boolean): void {
      this.permissionsFlag = permissionsFlag;
    },
    setIdeaVoterFlag(flag: boolean): void {
      this.ideaVoterFlag = flag;
    },
    setNotificationFlag(flag: boolean): void {
      this.notificationFlag = flag;
    },
  },
});
